import { Component, Host, h, Prop } from '@stencil/core';

@Component({
  tag: 'legrandav-h1text-primary',
  styleUrl: 'legrandav-h1text-primary.css',
  shadow: true,
})
export class LegrandavH1textPrimary {
  @Prop() text: string;

  render() {
    return (
      <Host>
        <h1>{this.text}</h1>
      </Host>
    );
  }
}
